"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = __importStar(require("react"));
const UserContext_1 = require("context/UserContext");
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const useClickOutside_1 = __importDefault(require("hooks/useClickOutside"));
const useObjectiveComment_1 = require("hooks/api/useObjectiveComment");
const RefetchQueryContext_1 = require("context/RefetchQueryContext");
const TextAreaWithMention_1 = __importDefault(require("components/shared/TextAreaWithMention/TextAreaWithMention"));
const CommentActivity = ({ closeComment, involvements, id }) => {
    const ref = (0, react_1.useRef)(null);
    const { refetchObjective } = (0, RefetchQueryContext_1.useRefetchQuery)();
    const { user, config } = (0, UserContext_1.useUser)();
    const [inputComment, setInputComment] = (0, react_1.useState)('');
    const [metaMentions, setMetaMentions] = (0, react_1.useState)([]);
    const includes = (config === null || config === void 0 ? void 0 : config.objectiveCommentMentionTarget) !== 'all'
        ? (involvements === null || involvements === void 0 ? void 0 : involvements.length) > 0
            ? involvements.map((involvement) => involvement.user.id)
            : []
        : [];
    const { mutate: submit } = (0, useObjectiveComment_1.usePostObjectiveComment)(id, {
        onSuccess: () => __awaiter(void 0, void 0, void 0, function* () {
            yield refetchObjective(id);
        })
    });
    const submitComment = () => {
        if (!inputComment)
            return;
        const payload = { comment: inputComment };
        submit(payload);
    };
    (0, useClickOutside_1.default)(ref, () => {
        if (inputComment)
            return;
        closeComment();
    });
    return (react_1.default.createElement("div", { ref: ref, "data-cy": `commentbox-${id}`, className: "flex w-full items-center bg-n-000 rounded-lg mt-[8px] pr-[16px] border border-solid border-n-400" },
        react_1.default.createElement(TextAreaWithMention_1.default, { currentUserId: user.id, setComment: setInputComment, metaMentions: metaMentions, setMetaMentions: setMetaMentions, includes: includes, modalType: "commentActivity", customClass: "border-0 w-full max-h-[32px]", ableToFocusGrow: false }),
        react_1.default.createElement(SVGIcon_1.default, { id: 'submit-comment', size: 18, iconName: "icon-send", fillColor: inputComment ? 'var(--base-600)' : `var(--n-600)`, customClass: "ml-[8px]", disabled: inputComment == '', onClick: e => {
                e.stopPropagation();
                submitComment();
            } })));
};
exports.default = CommentActivity;
